import { connect } from 'react-redux';

import QuickShopDualCTA from '../components/QuickShopDualCTA';
import { changeOrderMembership, changeSubscribingStatus } from '../actions';

const mapStateToProps = state => ({
  canBecomeMember: state.canBecomeMember,
  isMembershipOrder: state.currentOrder.membership_order,
});

export const mapDispatchToProps = dispatch => ({
  changeOrderMembership: (value, eventLocation) =>
    dispatch(changeOrderMembership(value, eventLocation)),
  changeSubscribingStatus: value => dispatch(changeSubscribingStatus(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuickShopDualCTA);
